export default __webpack_public_path__ + "static/media/checked.acc9df37.svg";